// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__1Gg07","expandIcon":"AccordionButton_expandIcon__3H_Qg","expanded":"AccordionButton_expanded__u-6J1"};